module.exports = __webpack_public_path__ + "img/seguridad.b6b1d4ad.png";